import React from "react";
import PropTypes from "prop-types";

import { Icon, Button } from "rbx";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const NoteCell = ({ cell }) => (
  <Button
    rounded
    color={cell.value ? "link" : "dark"}
    size="small"
    tooltip={cell.value}
    tooltipPosition="left"
  >
    <Icon>
      <FontAwesomeIcon icon="sticky-note" />
    </Icon>
  </Button>
);

NoteCell.propTypes = {
  cell: PropTypes.object
};

export default NoteCell;
